import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_not_allowed.svg';
import Icon, { IconProps } from './icon';

const IconNotAllowed = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconNotAllowed;
